import React, { useMemo } from 'react';

import MarkupsEntityBlockView from './MarkupEntityBlockView';
import useFetchMarkupsForDocs from './useFetchMarkupsForDocs';
import useFetchSurface from './useFetchSurface';
import ReferencePickerPlugin from '../../../types/ReferencePickerPlugin';
import { documentEntityLink } from '../helpers/utils';
import { DocumentEntity } from '../types/types';

const MarkupsEntityBlock: ReferencePickerPlugin<DocumentEntity>['EntityBlock'] =
  ({
    entity,
    projectId,
    onReferenceClickAnalytics,
    sourceEntityType,
    sourceEntityId,
  }) => {
    const { name, entityId, versionId } = entity;
    const { markups, isLoading } = useFetchMarkupsForDocs({
      projectId,
      entityVersionId: versionId,
      sourceEntityId,
      sourceEntityType,
    });
    const surfaceUid = useMemo(
      () => markups && markups[0]?.placement?.surface_uid,
      [markups],
    );
    const surface = useFetchSurface(projectId, surfaceUid);

    const url = useMemo(
      () =>
        projectId &&
        documentEntityLink({ projectId, entityId, markups, surface }),
      [entityId, markups, projectId, surface],
    );

    return (
      <MarkupsEntityBlockView
        name={name}
        url={url}
        sourceEntityType={sourceEntityType}
        markups={markups}
        isLoading={isLoading}
        onClick={() => onReferenceClickAnalytics?.()}
      />
    );
  };

export default MarkupsEntityBlock;
